import React, { useState } from 'react';
import Button from '../../../../Components/Button/Button';
import { Theme } from '../../../../Enums/Theme.enum';
import FormattedMomentDate, {
	DateFormat,
} from '../../../Base/Components/FormattedMomentDate/FormattedMomentDate';
// @ts-ignore
import styles from './IssuedLaboratoryRequestsListItem.module.scss';
import MediaViewerModal from '../../../../Components/MediaViewer/MediaViewerModal';
import { prepareDocumentationFileForMediaViewer } from '../../../Ecard/Services/eCardFile.service';
import { useAppContext } from '../../../../Services/AppContext';
import {
	DocumentationFile,
	useAddLaboratoryRequisitionToPatientMutation,
} from '../../../../graphql/graphql';
import LinkButton from '../../../../Components/Button/LinkButton';
import Text from '../../../../Components/Base/Text/Text';
import usePatientConsent from '../../../../Components/PatientProfile/Hooks/usePatientConsent';
import BaseModal from '../../../Base/Components/BaseModal/BaseModal';
import PatientNoConsentProvided from '../../../Patient/Components/PatientNoConsentProvided/PatientNoConsentProvided';

interface Props {
	patientId: string;
	item: {
		id: string;
		requisition: {
			name: string;
			laboratory: {
				name: string;
			};
		};
		createdAt: string;
		laboratoryExaminationRequest: DocumentationFile;
		laboratoryExaminationRequestPatientId?: string;
	};
	onSendToPatient: () => void;
}

const IssuedLaboratoryRequestsListItem: React.FC<Props> = ({
	item,
	patientId,
	onSendToPatient,
}) => {
	const [isFileOpen, setIsFileOpen] = useState(false);
	const [isNoConsentProvidedOpen, setIsNoConsentProvidedOpen] = useState(false);
	const { isConsentProvided } = usePatientConsent(patientId);
	const { socketUrl } = useAppContext();
	const [sendToPatient] = useAddLaboratoryRequisitionToPatientMutation();

	const handleSendToPatientsECard = async () => {
		if (isConsentProvided) {
			await sendToPatient({
				input: { laboratoryRequisitionResultId: item.id },
			});
			onSendToPatient();
		} else {
			setIsNoConsentProvidedOpen(true);
		}
	};

	return (
		<>
			<div className={styles.wrapper}>
				<div className={styles.date}>
					<FormattedMomentDate
						date={item.createdAt}
						format={DateFormat.DATE_TIME}
					/>
				</div>
				<div className={styles.content}>
					<div className={styles.title}>{item.requisition.name}</div>
					<div className={styles.subTitle}>
						{item.requisition.laboratory.name}
					</div>
				</div>
				<div className={styles.controls}>
					{item.laboratoryExaminationRequestPatientId ? (
						<div className={styles.inPatientsECard}>
							<img
								className={styles.check}
								src='/dist/icons/v2/check-green.svg'
								alt='green check'
							/>{' '}
							<Text
								inline
								tx='component.issuedLaboratoryRequestsListItem.isSendToPatient'
							/>
						</div>
					) : (
						<LinkButton
							title='component.issuedLaboratoryRequestsListItem.sendToPatientECard'
							theme={Theme.BLUE}
							onClick={handleSendToPatientsECard}
						/>
					)}
					<Button
						onClick={() => setIsFileOpen(true)}
						title='base.detail'
						theme={Theme.GREEN}
					/>
				</div>
			</div>
			{isFileOpen && (
				<MediaViewerModal
					opened
					onClose={() => setIsFileOpen(false)}
					file={prepareDocumentationFileForMediaViewer(
						item.laboratoryExaminationRequest,
						socketUrl,
					)}
				/>
			)}
			{isNoConsentProvidedOpen && (
				<BaseModal
					title='component.issuedLaboratoryRequestsListItem.cantBeSendToPatient'
					isOpen
					onClose={() => setIsNoConsentProvidedOpen(false)}>
					<PatientNoConsentProvided patientId={patientId} />
				</BaseModal>
			)}
		</>
	);
};

export default IssuedLaboratoryRequestsListItem;
